import { LOGO } from "../../layout/style";
import Logo from "../../assets/image/logo/Octaplex Logo.png";
import { Col, Divider, Flex, Layout, Row, theme } from "antd";
import { Outlet } from "react-router-dom";
const { Content } = Layout;

const RouteStyleOne = () => {
  const {
    token: { colorBgContainer, colorPrimary, borderRadiusLG, colorTextDescription },
  } = theme.useToken();

  return (
    <Layout style={{ height: "100svh", overflowY: "auto" }}>
      <Content style={{ overflowY: "auto" }}>
        <Row>
          <Col xs={{
            span: 20,
            offset: 2,
          }}
            md={{
              span: 18,
              offset: 4,
            }}
            lg={{
              span: 18,
              offset: 4,
            }}
          >
            <Flex vertical={true} justify='' style={{ height: "100svh", }}  >
              <div>
                <img src={Logo} height="36px" width='auto' alt='' style={LOGO.warpper} />
              </div>
              <Row>
                <Col span={24}>
                  <div style={{ height: 5, backgroundColor: colorPrimary, marginTop: 20 }}></div>
                </Col>
              </Row>
              <Outlet />
            </Flex>
          </Col>
        </Row>
        <Row>
        </Row>
      </Content>

    </Layout>
  );
};

export default RouteStyleOne;